import { ITools } from "src/lib/schemas";

export function getAssistantConfigEventTools(tools: ITools[]) {
    console.log('Configuring data channel');
    const event = {
      type: 'session.update',
      session: {
        // modalities: ['text', 'audio'],
        modalities: ['text'],
        tools: tools
      },
    };
    
    return event
  }